import React from 'react';
import Loader from '@/components/atoms/Loader';
import NavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { useRestaurantTabRoutes } from '../hooks/useRestaurantTabRoutes';
import { Container, Content } from './RestaurantInfo.style';
import { useRestaurantInfoVM } from './RestaurantInfo.viewmodel';
import { RestaurantInfoSection } from './components/RestaurantInfoSection';
import { LegalInfoSection } from './components/LegalInfoSection';
import { EwalletMinimumSection } from './components/EwalletMinimumSection';
import { DeleteRestaurantSection } from './components/DeleteRestaurantSection';
import { PickupScheduleSection } from './components/PickupScheduleSection';

const RestaurantInfo: React.FunctionComponent = () => {
    const {
        isLoading,
        isDeleting,
        restaurant,
        brandFamilies,
        isAdmin,
        hasRightOnRestaurantInfo,
        hasEducationMode,
        ewalletMinimum,
        restaurantForm,
        legalForm,
        brandId,
        restaurantDirtyCount,
        isSavingRestaurant,
        handleSaveRestaurant,
        handleCancelRestaurant,
        legalDirtyCount,
        isSavingLegal,
        handleSaveLegal,
        handleCancelLegal,
        ewalletDirtyCount,
        isSavingEwallet,
        handleSaveEwallet,
        handleCancelEwallet,
        handleDelete,
        setEwalletMinimum,
        addressText,
        addressData,
        handleAddressChange,
        legalAddressText,
        handleLegalAddressChange,
        pickupSchedules,
        handleScheduleChange,
        isSchedulesDirty,
        isSavingSchedules,
        handleSaveSchedules,
        handleCancelSchedules,
    } = useRestaurantInfoVM();

    const tabRoutes = useRestaurantTabRoutes();

    return (
        <NavigationTabs routes={tabRoutes}>
            <Container>
                <Content>
                    {isLoading ? (
                        <Loader withContainer />
                    ) : (
                        <>
                            <RestaurantInfoSection
                                form={restaurantForm}
                                restaurant={restaurant}
                                brandFamilies={brandFamilies}
                                hasRightOnRestaurantInfo={hasRightOnRestaurantInfo}
                                brandId={parseInt(brandId, 10)}
                                changesCount={restaurantDirtyCount}
                                isSaving={isSavingRestaurant}
                                onSave={handleSaveRestaurant}
                                onCancel={handleCancelRestaurant}
                                addressText={addressText}
                                onAddressChange={handleAddressChange}
                                addressCoords={addressData}
                            />
                            <LegalInfoSection
                                form={legalForm}
                                changesCount={legalDirtyCount}
                                isSaving={isSavingLegal}
                                onSave={handleSaveLegal}
                                onCancel={handleCancelLegal}
                                legalAddressText={legalAddressText}
                                onLegalAddressChange={handleLegalAddressChange}
                            />
                            <PickupScheduleSection
                                schedules={pickupSchedules}
                                onChange={handleScheduleChange}
                                isDirty={isSchedulesDirty}
                                isSaving={isSavingSchedules}
                                onSave={handleSaveSchedules}
                                onCancel={handleCancelSchedules}
                            />
                            {hasEducationMode && (
                                <EwalletMinimumSection
                                    value={ewalletMinimum}
                                    onChange={setEwalletMinimum}
                                    currency={restaurant?.currency || 'EUR'}
                                    changesCount={ewalletDirtyCount}
                                    isSaving={isSavingEwallet}
                                    onSave={handleSaveEwallet}
                                    onCancel={handleCancelEwallet}
                                />
                            )}
                            {isAdmin && (
                                <DeleteRestaurantSection
                                    createdAt={restaurant?.created_at}
                                    onDelete={handleDelete}
                                    isDeleting={isDeleting}
                                    brandId={brandId}
                                />
                            )}
                        </>
                    )}
                </Content>
            </Container>
        </NavigationTabs>
    );
};

export default RestaurantInfo;
